import React from "react"
import { Outlet } from "react-router-dom"

export function DataScriptOutlet() {
    return (
        <React.Fragment>
            <Outlet />
        </React.Fragment>
    );
}